import type { ReactNode } from "react";
import { Crosshair } from "lucide-react";
import { Button } from "@/components/ui/button";
import { OP_SURFACE } from "@/lib/opSurfaces";
import { cn } from "@/lib/utils";

export function OpNowBar({
  label,
  detail,
  actionLabel = "Pokaż",
  onAction,
  sticky = true,
  className,
  trailing,
}: {
  label: string;
  detail?: string;
  actionLabel?: string;
  onAction?: () => void;
  sticky?: boolean;
  className?: string;
  trailing?: ReactNode;
}) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-xl",
        OP_SURFACE.now.box,
        sticky && "sticky top-0 z-20",
        className,
      )}
    >
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
        <div className="flex min-w-0 items-start gap-2.5">
          <Crosshair className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden />
          <div className="min-w-0">
            <p className="text-xs font-bold uppercase tracking-wider text-brand">Teraz</p>
            <p className="text-base font-semibold text-slate-900">{label}</p>
            {detail ? <p className="mt-0.5 text-sm text-slate-700">{detail}</p> : null}
          </div>
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {trailing}
          {onAction ? (
            <Button type="button" variant="brand" size="default" onClick={onAction}>
              {actionLabel}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
